import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import Router from "./router";
import "./styles/css/global.scss";
import { Toaster } from "react-hot-toast";
import DynamicFavicon from "./components/DynamicFavicon";
import SubscriptionExpiredPopup from "./components/SubscriptionExpiredPopup";
import { createAppQueryClient } from "./utils/appUtils";
import { useSubscriptionPopup } from "./hooks/useSubscriptionPopup";

const queryClient = createAppQueryClient();

function App() {
  const {
    showSubscriptionPopup,
    handleSelectPlan,
    handleClosePopup,
  } = useSubscriptionPopup();

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <DynamicFavicon />
          <Router />
          <SubscriptionExpiredPopup
            open={showSubscriptionPopup}
            onClose={handleClosePopup}
            onSelectPlan={handleSelectPlan}
            disableClose={true}
          />
          <Toaster
            position="top-center"
            gutter={12}
            containerStyle={{ margin: "8px" }}
            toastOptions={{
              success: {
                duration: 3000,
              },
              error: {
                duration: 5000,
              },
              style: {
                fontSize: "16px",
                maxWidth: "500px",
                padding: "16px 24px",
                backgroundColor: "white",
                color: "black",
              },
            }}
          />
        </QueryClientProvider>
      </LocalizationProvider>
    </div>
  );
}

export default App;
